import React from 'react';
import { AnimatedSection } from './AnimatedSection';
import { Flame, Check } from 'lucide-react';
import { useLanguage } from './LanguageContext';
export function SpecialOffer() {
  const {
    t
  } = useLanguage();
  return <AnimatedSection data-id="element-206">
      <div className="max-w-4xl mx-auto bg-gradient-to-br from-barber-gold/20 to-barber-black border border-barber-gold p-8 md:p-12 rounded-2xl relative overflow-hidden" data-id="element-207">
        {/* Decorative elements */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-barber-gold/10 rounded-full blur-3xl -mr-32 -mt-32 pointer-events-none" data-id="element-208"></div>

        <div className="relative z-10 flex flex-col items-center text-center" data-id="element-209">
          <div className="inline-flex items-center gap-2 bg-red-500/20 text-red-500 px-4 py-1.5 rounded-full font-bold tracking-wider mb-6" data-id="element-210">
            <Flame size={18} data-id="element-211" />
            <span data-id="element-212">{t.specialOffer.badge}</span>
            <Flame size={18} data-id="element-213" />
          </div>

          <h2 className="text-3xl md:text-4xl font-oswald font-bold mb-4" data-id="element-214">
            {t.specialOffer.title}
          </h2>

          <div className="flex flex-col gap-4 my-8 text-left w-full max-w-md mx-auto" data-id="element-215">
            {t.specialOffer.benefits.map((benefit, index) => <div key={index} className="flex items-center gap-3" data-id="element-216">
                <div className="bg-barber-gold/20 p-1 rounded-full" data-id="element-217">
                  <Check className="text-barber-gold" size={20} data-id="element-218" />
                </div>
                <span className="text-lg font-medium" data-id="element-219">{benefit}</span>
              </div>)}
          </div>

          <p className="text-sm text-gray-400 italic" data-id="element-220">{t.specialOffer.note}</p>
        </div>
      </div>
    </AnimatedSection>;
}